import styled from 'styled-components';

import { Typography } from '@libs/components';

type ToolTipWrapperProps = {
  isVisible?: boolean;
  topMargin?: number;
};
export const ToolTipWrapper = styled.div<ToolTipWrapperProps>`
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  top: ${({ topMargin }) => (topMargin ? `-${topMargin}px` : '')};
  cursor: default;
  justify-self: center;
  flex-direction: column;
  position: absolute;

  padding: 0.6rem 0.9rem;
  gap: 0.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.x1};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  background-color: ${({ theme }) => theme.colors.surface.default};

  box-shadow: ${({ theme }) => theme.shadows.xl2};
`;

export const ToolTipDate = styled(Typography)`
  white-space: pre;
`;
